import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function EmailVerification() {
  const { user, checkAuth } = useAuth();
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('token') || '');
  const [message, setMessage] = useState('Conferma il tuo indirizzo per effettuare nuovi acquisti. Login e corsi già acquistati restano disponibili.');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (resend) => {
    setBusy(true);
    try {
      await api.post(resend ? '/auth/verification-email' : '/auth/verify-email', resend ? {} : { token });
      setMessage(resend ? 'Email inviata. Controlla anche la cartella spam.' : 'Indirizzo verificato. Puoi tornare al catalogo e acquistare.');
      if (!resend) { setDone(true); window.history.replaceState(null, '', window.location.pathname); if (user) await checkAuth(); }
    } catch (error) {
      const detail = error.response?.data?.detail;
      setMessage(typeof detail === 'string' ? detail : 'Operazione non riuscita. Riprova più tardi.');
    } finally { setBusy(false); }
  };
  return <main className="page-shell py-12 max-w-xl space-y-5">
    <h1 className="text-2xl font-bold">Verifica email</h1>
    <p role="status">{message}</p>
    {token && !done && <button className="rounded bg-brand p-3 text-white" disabled={busy} onClick={() => submit(false)}>Conferma indirizzo</button>}
    {user && !done && <button className="block underline" disabled={busy} onClick={() => submit(true)}>Invia un nuovo link</button>}
    {!user && <Link className="block underline" to="/accedi">Accedi per richiedere un nuovo link</Link>}
    <Link className="block underline" to="/concorsi">Torna al catalogo</Link>
  </main>;
}

